// Container da page de Consulta do notification-center (§4.2 da
// spec, superfície SIMPLIFICADA): barra de filtros essenciais +
// chips de deep-link + tabela. Todo o estado de filtros vive na URL
// — compartilhável. O detalhe do envio é uma PÁGINA dedicada
// (/notification-center/notifications/:uuid), não mais um drawer.
import { Suspense } from "react"
import { useTranslation } from "react-i18next"

import { NotificationSearchAppliedChips } from "./notification-search-applied-chips"
import { NotificationSearchFilters } from "./notification-search-filters"
import { NotificationsSearchTable } from "./notifications-search-table"

export const NotificationsSearch = () => {
  const { t } = useTranslation()

  return (
    <div className="space-y-4 @container">
      <header className="flex flex-col gap-1">
        <h1 className="text-2xl font-bold tracking-tight">
          {t("pages.notificationCenter.searchPage.title")}
        </h1>
        <p className="text-sm text-muted-foreground">
          {t(
            "pages.notificationCenter.searchPage.subtitle"
          )}
        </p>
      </header>
      <Suspense>
        <NotificationSearchFilters />
        <NotificationSearchAppliedChips />
        <NotificationsSearchTable />
      </Suspense>
    </div>
  )
}
